import Vue from 'vue';
import VueProgressBar from 'vue-progressbar';

const options = {
  color: '#007bff',
  failedColor: '#e24a41',
  thickness: '4px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
};

Vue.use(VueProgressBar, options);
